import { useAddGeorole } from '@data/georole-mutations';
import { EuiButton, EuiToolTip } from '@elastic/eui';
import { type FunctionComponent, useState, useCallback } from 'react';

interface GrantVrmProps {
  idnumber: string;
}

const GrantVrm: FunctionComponent<GrantVrmProps> = ({ idnumber }) => {
  const [loading, setLoading] = useState(false);
  const [addGeorole] = useAddGeorole();

  const handleClick = useCallback(() => {
    setLoading(true);
    Promise.all([
      addGeorole(idnumber, 'vrmProdEnv', [{ type: 'country', code: 'ZA' }]),
      addGeorole(idnumber, 'vrmCanvass', [{ type: 'country', code: 'ZA' }]),
      addGeorole(idnumber, 'vrmVoterEdit', [{ type: 'country', code: 'ZA' }]),
    ]).then(() => {
      setLoading(false);
    });
  }, [idnumber, addGeorole]);

  return (
    <EuiToolTip content="Grant basic VRM canvass and voter edit access">
      <EuiButton onClick={handleClick} isLoading={loading}>
        Grant VRM access
      </EuiButton>
    </EuiToolTip>
  );
};

export default GrantVrm;
